import { render, staticRenderFns } from "./LubricationData.vue?vue&type=template&id=189e3be7&"
import script from "./LubricationData.vue?vue&type=script&lang=js&"
export * from "./LubricationData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports